/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Southern Wind Warehouse API
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AndroidReleaseOut,
  DesktopReleaseOut
} from '../../model';

import { apiRequest } from '../../../http';
import type { ErrorType } from '../../../http';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Последняя версия приложения для Android (APK); 204 — выпусков на сервере нет
 */
export const desktopGetAndroidRelease = (
    
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<AndroidReleaseOut | void>(
      {url: `/api/v1/desktop/android`, method: 'GET', ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getDesktopGetAndroidReleaseQueryKey = () => {
    return [
    `/api/v1/desktop/android`
    ] as const;
    }

    
export const getDesktopGetAndroidReleaseQueryOptions = <TData = Awaited<ReturnType<typeof desktopGetAndroidRelease>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof desktopGetAndroidRelease>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDesktopGetAndroidReleaseQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof desktopGetAndroidRelease>>> = ({ signal }) => desktopGetAndroidRelease(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof desktopGetAndroidRelease>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DesktopGetAndroidReleaseQueryResult = NonNullable<Awaited<ReturnType<typeof desktopGetAndroidRelease>>>
export type DesktopGetAndroidReleaseQueryError = ErrorType<unknown>


export function useDesktopGetAndroidRelease<TData = Awaited<ReturnType<typeof desktopGetAndroidRelease>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof desktopGetAndroidRelease>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof desktopGetAndroidRelease>>,
          TError,
          Awaited<ReturnType<typeof desktopGetAndroidRelease>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDesktopGetAndroidRelease<TData = Awaited<ReturnType<typeof desktopGetAndroidRelease>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof desktopGetAndroidRelease>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof desktopGetAndroidRelease>>,
          TError,
          Awaited<ReturnType<typeof desktopGetAndroidRelease>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDesktopGetAndroidRelease<TData = Awaited<ReturnType<typeof desktopGetAndroidRelease>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof desktopGetAndroidRelease>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Последняя версия приложения для Android (APK); 204 — выпусков на сервере нет
 */

export function useDesktopGetAndroidRelease<TData = Awaited<ReturnType<typeof desktopGetAndroidRelease>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof desktopGetAndroidRelease>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDesktopGetAndroidReleaseQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Последняя версия программы для Windows; 204 — выпусков на сервере нет
 */
export const desktopGetRelease = (
    
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<DesktopReleaseOut | void>(
      {url: `/api/v1/desktop/release`, method: 'GET', ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getDesktopGetReleaseQueryKey = () => {
    return [
    `/api/v1/desktop/release`
    ] as const;
    }

    
export const getDesktopGetReleaseQueryOptions = <TData = Awaited<ReturnType<typeof desktopGetRelease>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof desktopGetRelease>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDesktopGetReleaseQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof desktopGetRelease>>> = ({ signal }) => desktopGetRelease(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof desktopGetRelease>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DesktopGetReleaseQueryResult = NonNullable<Awaited<ReturnType<typeof desktopGetRelease>>>
export type DesktopGetReleaseQueryError = ErrorType<unknown>


export function useDesktopGetRelease<TData = Awaited<ReturnType<typeof desktopGetRelease>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof desktopGetRelease>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof desktopGetRelease>>,
          TError,
          Awaited<ReturnType<typeof desktopGetRelease>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDesktopGetRelease<TData = Awaited<ReturnType<typeof desktopGetRelease>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof desktopGetRelease>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof desktopGetRelease>>,
          TError,
          Awaited<ReturnType<typeof desktopGetRelease>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDesktopGetRelease<TData = Awaited<ReturnType<typeof desktopGetRelease>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof desktopGetRelease>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Последняя версия программы для Windows; 204 — выпусков на сервере нет
 */

export function useDesktopGetRelease<TData = Awaited<ReturnType<typeof desktopGetRelease>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof desktopGetRelease>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDesktopGetReleaseQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




